import 'utils/filter_form';
import 'utils/autofill_by_query_string';
import 'components/alphabetical_input';

(function ($) {
  const $filterForm = $('#js-examining-board-filter-form');

  $filterForm
    .autoFillByQueryString()
    .filterForm()
    .lazyReady();

//   $filterForm.on('submit', () => {
//     $filterForm.trigger('filterFormToggle');
//     return false;
//   });
})(jQuery);
